import { useQuery } from "@tanstack/react-query"
import { fetchAnalytics } from "../../api/orders.api";

export const useFetchInfo = () => {
  const { data, isLoading, isPending } = useQuery({
    queryKey: ["adm-dashboard-info"],
    queryFn: () => fetchAnalytics(),
    staleTime: 1000 * 60 * 1,
    refetchOnWindowFocus: false,
  });

  return { data, isLoading, isPending };
};